// routes/AdminRoutes.jsx
import ProtectedRoute from '../Utils/ProtectedRoute.jsx';
import { lazy } from 'react';
import Loadable from '../Components/Loadable.js';
import { MENU_ITEMS } from '../assests/Constants/menuRestrictionKeys.js';
import UserActivityPage from '../pages/UserActivities/UserActivities.jsx';

const AccountantDetails = Loadable(lazy(() => import('../pages/AccountantDetails/AccountantDetails.jsx')));
const AddClient = Loadable(lazy(() => import('../pages/AddClient/AddClient.jsx')));
const Assets = Loadable(lazy(() => import('../pages/Assets/Assets.jsx')));
const CollectionPage = Loadable(lazy(() => import('../pages/CollectionPage/CollectionPage.jsx')));
const CreditTerminalPage = Loadable(lazy(() => import('../pages/CreditTerminalPage/CreditTerminalPage.jsx')));
const FinsitePage = Loadable(lazy(() => import('../pages/FinsitePage/FinsitePage.jsx')));
const Assignments = Loadable(lazy(() => import('../pages/Assignments/Assignments.jsx')));
const HoldingItems = Loadable(lazy(() => import('../pages/HoldingItems/HoldingItems.jsx')))
const DocumentsRequiringClarification = Loadable(lazy(() => import('../pages/DocumentsRequiringClarification/DocumentsRequiringClarification.jsx')))
const ReportTracking = Loadable(lazy(() => import('../pages/ReportTracking/ReportTracking.jsx')));
const SubAccountant = Loadable(lazy(() => import('../pages/SubAccountants/SubAccountants.jsx')));
const JournalEntry = Loadable(lazy(() => import('../pages/JournalEntryies/JournalEntry.jsx')));
const BankMatching = Loadable(lazy(() => import('../pages/BankMatching/BankMatching.jsx')));
const CardMatching = Loadable(lazy(() => import('../pages/CardMatching/CardMatching.jsx')));
const BankPages = Loadable(lazy(() => import('../pages/BankPages/BankPages.jsx')));
const SignDocumentPage = Loadable(lazy(() => import('../pages/SignatureDocument/SignDocumentPage.jsx')));
const SignatureSuccessPage = Loadable(lazy(() => import('../pages/SignatureDocument/SignatureSuccessPage.jsx')));

const PermissionRoutes = {
  path: '/',
  children: [
    {
      path: 'Accountant-details',
      element: (
        <ProtectedRoute unauthorizedPermission={['ViewSubAccountantClients']} preventClient={true}>
          <AccountantDetails />
        </ProtectedRoute>
      )
    },
    {
      path: 'AddClient',
      element: (
        <ProtectedRoute unauthorizedPermission={['CannotAddClient']}>
          <AddClient />
        </ProtectedRoute>
      )
    },
    {
      path: 'Assets',
      element: (
        <ProtectedRoute preventManageOnly={true} unauthorizedPermission={['CannotAddClient']} restrictionMenuKey={MENU_ITEMS.Assets}>
          <Assets />
        </ProtectedRoute>
      )
    },
    {
      path: 'HoldingItems',
      element: (
        <ProtectedRoute preventManageOnly={true} unauthorizedPermission={['CannotAddClient']} restrictionMenuKey={MENU_ITEMS.HoldingItems}>
          <HoldingItems />
        </ProtectedRoute>
      )
    },
    {
      path: 'DocumentsRequiringClarification',
      element: (
        <ProtectedRoute preventClient={true} preventManageOnly={true} unauthorizedPermission={['CannotAddClient']} restrictionMenuKey={MENU_ITEMS.DocumentsRequiringClarification}>
          <DocumentsRequiringClarification />
        </ProtectedRoute>
      )
    },
    {
      path: 'CollectionPage',
      element: (
        <ProtectedRoute unauthorizedPermission={['ViewSubAccountantClients','CantSeeCollectionPage']} preventClient={true}>
          <CollectionPage />
        </ProtectedRoute>
      )
    },
    {
      path: 'CreditTerminal',
      element: (
        <ProtectedRoute>
          <CreditTerminalPage />
        </ProtectedRoute>
      )
    },
    {
      path: 'Finsite',
      element: (
        <ProtectedRoute preventClient={true}>
          <FinsitePage />
        </ProtectedRoute>
      )
    },
    {
      path: 'Assignments',
      element: (
        <ProtectedRoute unauthorizedPermission={['ViewSubAccountantClients']} preventClient={true}>
          <Assignments />
        </ProtectedRoute>
      )
    },
    {
      path: 'user-activities',
      element: (
        <ProtectedRoute requireAccountant preventClient={true}>
          <UserActivityPage />
        </ProtectedRoute>
      )
    },
    {
      path: 'TrackingList',
      element: (
        <ProtectedRoute preventClient={true}>
          <ReportTracking />
        </ProtectedRoute>
      )
    },
    {
      path: 'SubAccountants',
      element: (
        <ProtectedRoute requireAccountant preventClient={true}>
          <SubAccountant />
        </ProtectedRoute>
      )
    },
    {
      path: 'JournalEntry',
      element: (
        <ProtectedRoute preventManageOnly={true} premiumClientOnly={true} restrictionMenuKey={MENU_ITEMS.JournalEntries}>
          <JournalEntry />
        </ProtectedRoute>
      )
    },
    {
      path: 'BankTransactions',
      element: (
        <ProtectedRoute preventManageOnly={true} premiumClientOnly={true} restrictionMenuKey={MENU_ITEMS.BankMatching}>
          <BankMatching />
        </ProtectedRoute>
      )
    },
    {
      path: 'CardMatching',
      element: (
        <ProtectedRoute preventManageOnly={true} premiumClientOnly={true} restrictionMenuKey={MENU_ITEMS.CardMatching}>
          <CardMatching />
        </ProtectedRoute>
      )
    },
    {
      path: 'BankPages',
      element: (
        <ProtectedRoute preventManageOnly={true} premiumClientOnly={true} restrictionMenuKey={MENU_ITEMS.BankPages}>
          <BankPages />
        </ProtectedRoute>
      )
    },
    {
      path: 'sign-document/:documentId',
      element: (
        <ProtectedRoute clientOnly={true} validateDocumentOwnership={true}>
          <SignDocumentPage />
        </ProtectedRoute>
      )
    },
    {
      path: 'signature-success',
      element: (
        <ProtectedRoute>
          <SignatureSuccessPage />
        </ProtectedRoute>
      )
    },
  ]
};

export default PermissionRoutes;
